// @flow

import * as React from 'react'
import { Label, Button } from 'semantic-ui-react'
import Bar from './bar'
import moment from 'moment'
// $FlowFixMe
import 'moment/locale/it'

import './calendar-card.css'

import type { ChartSampling } from '../store/reports'
import type { RangedAggregatedVisits } from './calendar-report'

type DayCardProps = {|
  showWeb: boolean,
  showF2F: boolean,
  showPhone: boolean,
  date: string,
  data: RangedAggregatedVisits,
  showDetails: Function,
  disabled: boolean,
  chartSampling: ChartSampling,
  isViewer: boolean,
|}

class CalendarCard extends React.Component<DayCardProps> {
  static defaultProps = {
    showDetails: () => {},
    data: {
      web: 0,
      phone: 0,
      f2f: 0,
    },
  }

  render() {
    let date = moment(this.props.date)

    let web = this.props.data.web
    let f2f = this.props.data.f2f
    let phone = this.props.data.phone

    let tot = 0 + (this.props.showWeb ? web : 0) + (this.props.showPhone ? phone : 0) + (this.props.showF2F ? f2f : 0)
    let classes = `cell ${this.props.chartSampling} ${this.props.disabled ? ' disabled' : ''}`

    let color = ''
    if (this.props.chartSampling === 'DAILY') {
      color = date.format('d') === '0' ? 'red' : ''
    }

    return (
      <div className={classes}>
        <div className="day-card">
          <div className="title-container">
            {!this.props.disabled &&
              this.props.isViewer === false &&
              tot > 0 && (
                <Button
                  circular
                  style={{ padding: '.35rem' }}
                  icon="info"
                  size="mini"
                  value={this.props.date.replace(/-/g, '')}
                  onClick={this.props.showDetails}
                />
              )}
            <Label basic={!this.props.disabled} style={{ float: 'right', color: color }}>
              {this.props.data.name}
            </Label>
          </div>

          {!this.props.disabled &&
            tot > 0 && (
              <div className="graph-container">
                <div className="inner-graph-container">
                  {this.props.showWeb && <Bar value={web} total={tot} color="#2185D0" />}
                  {this.props.showF2F && <Bar value={f2f} total={tot} color="#21BA45" />}
                  {this.props.showPhone && <Bar value={phone} total={tot} color="#F2711C" />}
                </div>
              </div>
            )}
          <div className="total-container">
            Visite Totali: <b>{tot}</b>
          </div>
        </div>
      </div>
    )
  }
}

export default CalendarCard



// WEBPACK FOOTER //
// ./src/reports/calendar-card.js